/**
 * Enum to control the different states of the trajectory creation
 * CreatingInitialTrack: The user is about to add a takeoff for a new initial track.
 * InInitialTrack: just after adding the takeoff the users can add all the waypoints, forks or regions they need to define the initial track.
 *                 The creation of the initial will finish when the user manually change to create the mission stage, another initial or the
 *                 arrival stage.
 * CreatingForkTrack: The user is creating a fork track (state used to add all the other forks but not the first)
 * InForkTrack: The user is in a fork track (state only used for the first fork track added so just after adding a ForkRoute Waypoint)
 * InMission: The user is in the mission
 * CreatingArrivalTrack: The user is creating the arrival track
 * InArrivalTrack: The user is in the arrival track
 * LandingAdded: The landing has been added
 */
export enum TrajectoryState {
    CreatingInitialTrack,
    InInitialTrack,
    CreatingForkTrack,
    InForkTrack,
    InMission,
    CreatingArrivalTrack,
    InArrivalTrack,
    CreatingMissionArea,
    ClosingMissionArea,
    CreatingMissionAreaInFork,
    ClosingMissionAreaInFork,
    LandingAdded
}